const SITE_NAME = "Подуяне Днес";
const DEFAULT_DESCRIPTION =
  "Независима хиперлокална медия за район Подуяне, София — новини, инциденти, ремонти, трафик и граждански сигнали.";

// React 19 native document metadata: <title>, <meta> and <link> rendered here
// are automatically hoisted into <head>. No helmet library needed.
export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  image,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} — ${SITE_NAME}`
    : `${SITE_NAME} — хиперлокални новини за район Подуяне`;

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const url = `${origin}${path}`;
  let ogImage = image || `${origin}/og-default.jpg`;
  if (ogImage.startsWith("/")) ogImage = `${origin}${ogImage}`;

  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="bg_BG" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLdArray.map((data, i) => (
        <script
          key={`jsonld-${i}`}
          type="application/ld+json"
          suppressHydrationWarning
        >
          {JSON.stringify(data)}
        </script>
      ))}
    </>
  );
}
